import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, mapMany, isSubset, setEquals, contains } from "keautils";
import { validation, formfields } from "kea-react"
import { componentToRx } from "react-rxk";
import { fa } from "typed-font-awesome";
import { observeResource } from "kea-resource";
import { SelectedFactura } from "./types";
import { columnas } from "./columns";

export interface Props {
    /**Id de la factura seleccionada*/
    value: number;
    onChange: (x: number) => void;
}

/**Obtiene todos los folios sugeridos */
function getTodasFacturas(facturas: models.Factura[]) {
    const todas = facturas.map(x => x.IdRegistro);
    return todas;
}


/**Determina si una factura esta seleccionada */
function estaSeleccionada(item: models.Factura, selected: number[]): boolean {
    return contains(selected, item.IdRegistro);
}

/**Obtiene un conjunto de guias a un conjunto de SelectedGuia */
export function toSelected(items: models.FacturaDto[], selected: number[]): SelectedFactura[] {
    const ret = items ? items.map(x => ({ ...x, Selected: estaSeleccionada(x, selected) })) : [];
    return ret;
}

export interface State {
    idCliente?: number;
}

class CrearNotasDeCreditoFormNoRx extends React.PureComponent<Props, State> {
    constructor(props) {
        super(props);
        this.state = {};
    }

    onSeleccionar = (factura: models.FacturaDto, selected: boolean) => {
        this.props.onChange(factura.IdRegistro);
    };

    value = (props: Props, state: State) => props.value;
    filtro = (props: Props, state: State): models.FiltroFacturas => ({
        IdCliente: state.idCliente,
        EsTimbrada: true,
        EsCancelada: false
    });

    items = createSelectorRx(this.filtro, filtro => observeResource(resources.Factura.Query, filtro));

    itemsSelected = createSelectorRx(this.value, this.items, (value, items) => toSelected(items, [value]));

    render() {
        const cols = columnas(this);
        return (
            <div>
                <div className="alert alert-info">
                    Seleccionar la factura. Se muestran sólo las facturas timbradas que no están canceladas.
                </div>
                <div>
                    {kea.autogrid(3, [
                        <selectores.Cliente value={this.state.idCliente} onChange={x => this.setState({ idCliente: x as number })} label="Cliente" />
                    ])}
                </div>

                <kea.Grid2 cookieKey="multiselectorFactura" items={this.itemsSelected(this.props, this.state)} columnas={cols} hideBusqueda={false} />
            </div>
        )
    }
}

export const CrearNotasDeCreditoForm = componentToRx(CrearNotasDeCreditoFormNoRx);



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/facturas/notacredito/generarnotasdecredito/form.tsx